import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import { EventsApi } from './events-api.service';

export const eventState = {
   parent: 'app',
   name: 'event',
   abstract: true,
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager,EventManager',
      nav: {
         title: 'Events',
         icon: 'e360-icon-events',
         children: [
            {
               title: 'Events',
               stateName: 'event.list',
               otherStates: [ 'event.add', 'event.edit', 'event.copy' ]
            },
            { title: 'Media', stateName: 'event.media' },
            {
               title: 'Participants',
               stateName: 'event.participants',
               otherStates: [ 'event.addParticipant', 'event.editParticipant' ]
            },
            {
               title: 'Pre-Registrations',
               stateName: 'event.prereg',
               otherStates: [ 'event.addPreReg', 'event.editPreReg', 'event.addGuest', 'event.editGuest' ]
            },
            {
               title: 'Invitees',
               stateName: 'event.invitees',
               otherStates: [ 'event.addInvitee', 'event.editInvitee' ]
            }
         ]
      }
   }
};

export const eventListState = {
   name: 'event.list',
   url: '/events',
   controller: 'EventListController as $ctrl',
   templateUrl: require('./event-list.html')
};

export const eventAddState = {
   name: 'event.add',
   url: '/events/add',
   controller: 'EventEditController as ctrl',
   templateUrl: require('./event-edit.html')
};

export const eventEditState = {
   name: 'event.edit',
   url: '/events/:id',
   controller: 'EventEditController as ctrl',
   templateUrl: require('./event-edit.html')
};

export const eventCopyState = {
   name: 'event.copy',
   url: '/events/duplicate/:id',
   controller: 'EventEditController as ctrl',
   templateUrl: require('./event-edit.html')
};

export const eventMediaState = {
   name: 'event.media',
   url: '/media',
   controller: 'EventMediaController',
   templateUrl: require('./media/view.html'),
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const eventParticipantsState = {
   name: 'event.participants',
   url: '/participants',
   templateUrl: require('./participant/list-view.html'),
   controller: 'EventDataController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const addParticipantState = {
   name: 'event.addParticipant',
   url: '/participants/add?eventId',
   templateUrl: require('./participant/participant-view.html'),
   controller: 'EditParticipantController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const editParticipantState = {
   name: 'event.editParticipant',
   url: '/participants/:id',
   templateUrl: require('./participant/participant-view.html'),
   controller: 'EditParticipantController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const eventPreRegState = {
   name: 'event.prereg',
   url: '/prereg',
   templateUrl: require('./participant/list-view.html'),
   controller: 'EventDataController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const addPreRegState = {
   name: 'event.addPreReg',
   url: '/prereg/add?eventId',
   templateUrl: require('./participant/prereg-view.html'),
   controller: 'EditPreRegController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const editPreRegState = {
   name: 'event.editPreReg',
   url: '/prereg/:id',
   templateUrl: require('./participant/prereg-view.html'),
   controller: 'EditPreRegController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const addGuestState = {
   name: 'event.addGuest',
   url: '/guests/add?hostId&eventId',
   templateUrl: require('./participant/prereg-view.html'),
   controller: 'EditPreRegController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const editGuestState = {
   name: 'event.editGuest',
   url: '/guests/:id',
   templateUrl: require('./participant/prereg-view.html'),
   controller: 'EditPreRegController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const eventInviteeState = {
   name: 'event.invitees',
   url: '/invitees',
   templateUrl: require('./participant/list-view.html'),
   controller: 'EventDataController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const addInviteeState = {
   name: 'event.addInvitee',
   url: '/invitees/add?eventId',
   templateUrl: require('./participant/invitee-view.html'),
   controller: 'EditInviteeController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const editInviteeState = {
   name: 'event.editInvitee',
   url: '/invitees/:id',
   templateUrl: require('./participant/invitee-view.html'),
   controller: 'EditInviteeController',
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager'
   }
};

export const adminEventsState = {
   name: 'admin.events',
   url: '/events',
   templateUrl: require('./event-admin-list.html'),
   controller: 'EventAdminListController as $ctrl',
   data: {
      disableOrganizationSelection: true,
      disableBrandSelection: true,
      disableCampaignSelection: true
   }
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(eventState);
   $stateRegistry.register(eventListState);
   $stateRegistry.register(eventAddState);
   $stateRegistry.register(eventEditState);
   $stateRegistry.register(eventCopyState);
   $stateRegistry.register(eventMediaState);
   $stateRegistry.register(eventParticipantsState);
   $stateRegistry.register(addParticipantState);
   $stateRegistry.register(editParticipantState);
   $stateRegistry.register(eventPreRegState);
   $stateRegistry.register(addPreRegState);
   $stateRegistry.register(editPreRegState);
   $stateRegistry.register(addGuestState);
   $stateRegistry.register(editGuestState);
   $stateRegistry.register(eventInviteeState);
   $stateRegistry.register(addInviteeState);
   $stateRegistry.register(editInviteeState);
   $stateRegistry.register(adminEventsState);
}
